<ng-container>
    <button (click)="closeModals()" class="close-compate-btn">
      <i class="fa fa-x"></i>
    </button>
    <app-my-carousel-swiper class="my-carousel-width-auto" 
    [config]="compareProductCarouselOptions">
    <ng-container *ngFor="let productData of productsToCompare; index as i" >
        <div class="swiper-slide d-flex justify-content-center">
          <!-- <app-view-product-details [productLoader]="false" [modal]="compareProductsModal"  
          [productData]="productData" ></app-view-product-details> -->
          <!-- <div>{{productData.name}}</div> -->
         
          <div class="card pop">
            <span class="prod-title p-2">{{productData?.name | titlecase}}
              <ng-container  *ngIf="productData?.companyName && productData?.companyName != 'null'">
                by <span *ngFor="let word of productData?.companyName?.split(' ') "> {{word}}</span>
      
              </ng-container>

            </span>
            <div class="prod-images">
              <div class="main-image">
                @if(isMainImageselectedForProduct[i]){
                <div class="mr-1">
                  <app-cropped-image [imgSrc]="imgUrl + productData?.indexImage" borderRadius="20px"
                  [cropInformation]="productData?.mainImageCropInformation" ></app-cropped-image>
                </div>
                
  
                }@else{
                  <img [src]="imgUrl + showImageLocation[i]" 
                  (error) ="onImgError($event)" style="width: auto !important;" /> 
                }
              </div>
            
    
              <div class="slide-images">
                <ng-container
                  *ngFor="let image of [productData?.food_image_1, productData?.food_image_2, productData?.food_image_3, productData?.food_image_4]; index as j">
                  <div *ngIf="image != ''" (click)="changeShowImageProduct(i, image, j)" (error)="handleError($event)"
                    [ngStyle]="{ 'background-image': 'url(' + imgUrl + image + ')' }"></div>
                </ng-container>
              </div>
            </div>
            <div class="card-body">
              <ng-container>
                <div class="all-reviews d-flex flex-column mt-1" style="height: 3.3rem;">
                  <div class="mt-2" *ngIf=" !productData?.ratings ||  productData?.ratings?.length == 0">
                     <i class="fas fa-heart-broken mr-2"></i> No Rating Information Present
                  </div>

                <app-my-carousel-swiper  class="w-100" [navigation]="false"  [config]="ratingsCarouselOptions"
                *ngIf=" (productData?.ratings &&  productData?.ratings?.length) ||  (productData?.otherRatingBadges &&  productData?.otherRatingBadges?.length)">
                      <ng-container *ngFor="let rating of productData.ratings">
                        <div [class.full-rw]="productData?.ratings?.length==1" [class.swiper-slide]="productData?.ratings?.length > 1" *ngIf="rating.rating || rating.counts">
                        
                        <div class="seller-info flex-row no-after justify-content-center" 
                          (click)="openCorrectedSite(rating.ratingUrl)">
                          <img [src]="'../../../../../assets/images/' + rating.icon" class="rating-img mt-1" style="width: 2.5rem !important;"/>
                          
                         
                          <div class="star-rating d-flex flex-column align-items-center mt-1 mr-2">
                            <div class="rating mr-2">{{ rating.rating | number: "1.1-1" || 0 }}</div>
                            <div class="stars-outer ">
                              <div class="stars-inner" [style.width.%]="(rating.rating / 5) * 100"></div>
                            </div>
                            <div class="rating-name d-flex align-items-start mt-1" style="height: fit-content !important; font-size: .7em;">
                              <span class="number mr-1" style="font-size: 1.05em;">
                                {{ rating.counts || 0 }}
                              </span>
                              <span>Reviews</span>
                            </div>
                            
                            
                          </div>
                        
                          
                        </div>
                       </div>
                      </ng-container>
                      <ng-container *ngFor="let rating of productData.otherRatingBadges">
                        <div  [class.full-rw]="productData?.ratings?.length==1" [class.swiper-slide]="productData?.ratings?.length > 1" *ngIf="rating.rating || rating.counts">
                        
                          <div class="seller-info flex-row no-after justify-content-center" 
                            (click)="openCorrectedSite(rating.ratingUrl)">
                            <img [src]="'../../../../../assets/images/' + rating.icon" class="rating-img mt-1" style="width: 2.5rem !important;"/>
                            
                           
                            <div class="star-rating d-flex flex-column align-items-center mt-1 mr-2">
                              <div class="rating mr-2">{{ rating.rating | number: "1.1-1" || 0 }}</div>
                              <div class="stars-outer ">
                                <div class="stars-inner" [style.width.%]="(rating.rating / 5) * 100"></div>
                              </div>
                              <div class="rating-name d-flex align-items-start mt-1" style="height: fit-content !important; font-size: .7em;">
                                <span class="number mr-1" style="font-size: 1.05em;">
                                  {{ rating.counts || 0 }}
                                </span>
                                <span>Reviews</span>
                              </div>
                              
                              
                            </div>
                          
                            
                          </div>
                         </div>
                      </ng-container>
                   
  
                  
                </app-my-carousel-swiper>
              </div>
         
              </ng-container>
              <div class="price">{{productData?.price}}</div>
              <!-- <div class="middle">Fuel middle<br>8.5/7.1 L/100km</div> -->
              <div class="w-100 d-flex justify-content-between align-items-center">
                
  
  
                <div class="d-flex w-100 justify-content-between ml-2 mr-2">
                  <div class="verified-tag"  [class.verified]="!specialTags.has(productData?.verifiedTag?.trim())"  [class.verified-special]="specialTags.has(productData?.verifiedTag?.trim())" *ngIf="productData?.productVerficationsList?.length" style="width: fit-content; height: fit-content;">
                    {{ (productData.verifiedTag?.trim()?.length ? productData.verifiedTag : "Verified").toLowerCase() | titlecase }}
                    <div class="rhoumbus-outer " *ngIf="!specialTags.has(productData?.verifiedTag?.trim())">
                     
                      <div class="rhoumbus-inner" [style.width.%]="(verifiedTagRating(productData) / 3) * 100"></div>
                    </div>
                  </div>
                  
                  <span style="font-weight: bold;" class="mb-1" placement="top" ngbTooltip="{{ (productData?.subRegionName?.split(',').includes('all') ? 'Doorstep' : regionSplit(productData?.subRegionName)) | titlecase }}">
                    {{ (productData?.subRegionName?.split(",").includes("all") ? "Doorstep" : regionSplit(productData?.subRegionName)) | titlecase }}
                  </span>
              
    
                
                  
                </div>
              
              </div>
            

              <div class="verified w-100 flex-column mb-2" [class.justify-content-center]="productData?.productVerficationsList?.length == 0">
                <div class="mt-1" *ngIf="productData?.productVerficationsList?.length == 0"><i class="fas fa-heart-broken mr-2"></i> No Verified Information Present</div>
              
              
                <ng-container *ngFor="let item of productData?.productVerficationsList">
                  <div *ngIf="item != ''" class="product-verfications w-100">
                    <div class="product-verfications__left">
                      @if(item?.isGolden){
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <defs>
                            <filter id="gold-glow" x="-50%" y="-50%" width="200%" height="200%">
                              <feGaussianBlur in="SourceAlpha" stdDeviation="3" result="blur"/>
                              <feOffset dx="0" dy="0" result="offsetBlur"/>
                              <feFlood flood-color="#FFD700" result="color"/>
                              <feComposite in="color" in2="offsetBlur" operator="in" result="glow"/>
                              <feMerge>
                                <feMergeNode in="glow"/>
                                <feMergeNode in="SourceGraphic"/>
                              </feMerge>
                            </filter>
                          </defs>
                        
                          <!-- Star with bright gold and glow -->
                          <path 
                            d="M12 2L14.5 4L18 3.5L19 7L22 9L20.5 12L22 15L19 17L18 20.5L14.5 20L12 22L9.5 20L6 20.5L5 17L2 15L3.5 12L2 9L5 7L6 3.5L9.5 4L12 2Z" 
                            fill="#FFD700" 
                            filter="url(#gold-glow)" 
                            stroke="none" 
                          />
                        
                          <!-- White check mark -->
                          <path 
                            d="M8.5 12L11 14.5L16 9.5" 
                            stroke="white" 
                            stroke-width="2" 
                            stroke-linecap="round" 
                            stroke-linejoin="round" 
                          />
                        </svg>
                                            
                      }
                      @else{
                        <svg viewBox="0 0 24 24" fill="none" stroke="var(--primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 2L14.5 4L18 3.5L19 7L22 9L20.5 12L22 15L19 17L18 20.5L14.5 20L12 22L9.5 20L6 20.5L5 17L2 15L3.5 12L2 9L5 7L6 3.5L9.5 4L12 2Z" fill="var(--primary)" stroke="none" />
                          <path d="M8.5 12L11 14.5L16 9.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> 
  
                      }
                      
                      <div class="text d-inline">{{ item.value }} <button [class.glow-less]="item.likeCounts" [class.reaction-liked]="item.haveILiked" class="d-inline ml-2">
                        <i class="fa fa-thumbs-up"></i>
                        @if (item.likeCounts) {
                          <span class="number"><span>X</span>{{ item.likeCounts }}</span>
                        }
                      </button></div>
                      
                    </div>
  
                    
                  </div>
                </ng-container>
              </div>
  
             
             
              
              <a  *ngIf="(productData?.type == 'promote' ?
              productData?.shoutContact : productData?.seller?.w_phone_number)"  target="_blank" class="contact-btn" [href]="'https://wa.me/' + (productData?.type == 'promote' ?
                productData?.shoutContact : productData?.seller?.w_phone_number)
              "><i class="fa-brands fa-whatsapp"></i> Contact</a>
            
            </div>
            <div class="p-2" style="height: 30vh; overflow-y: scroll;" *ngIf="productData?.forum?.replies?.length || productData?.xpCount ">
              <app-my-tabs [tabs]="productBottomDiscussExperienceTabSettings[i]" design="5">
              
                <div tab0>
                  <app-marketplace-recommendation  [showAddBtn]="false" [productData]="productData" [enableMemberShop]="true">
                  </app-marketplace-recommendation>
                </div>
                <div tab1>
                  <app-marketplace-forum
                    [productForum]="productData?.forum"></app-marketplace-forum>
                </div>
            
  
            </app-my-tabs></div>
      
  
            
          </div>
        
        </div>
      </ng-container>
    
  
    </app-my-carousel-swiper>
  

</ng-container>